import { cn } from '@/utils/cn'

export interface CardProps {
  children: HTMLElement | HTMLElement[]
  className?: string
  hover?: boolean
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl'
  glass?: boolean
}

export function Card({
  children,
  className,
  hover = false,
  padding = 'md',
  glass = false,
}: CardProps): HTMLElement {
  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
    xl: 'p-10',
  }

  const card = document.createElement('div')

  // Base classes
  let baseClasses = glass
    ? 'glass rounded-2xl'
    : 'bg-white rounded-2xl border border-slate-100 shadow-sm'

  if (hover) {
    baseClasses += glass
      ? ' transition-all duration-300 hover:shadow-glass-hover hover:-translate-y-1'
      : ' transition-all duration-300 hover:shadow-xl hover:shadow-slate-200/50 hover:-translate-y-1 hover:border-orange-100'
  }

  card.className = cn(
    baseClasses,
    paddings[padding],
    className
  )

  if (Array.isArray(children)) {
    children.forEach(child => card.appendChild(child))
  } else {
    card.appendChild(children)
  }

  return card
}
